"use client";
import { motion } from 'framer-motion';

export default function Hero404() { const ANIM_DURATION = parseFloat("1");
const ANIM_EASING = JSON.parse("[0.42,0,0.58,1]");
const TRANSITION_ANIM_TYPE = "FLIP_IN_X";
const transitionVariants: any = { FADE_IN: { hidden: { opacity: 0 }, show: { opacity: 1, transition: { duration: ANIM_DURATION, ease: ANIM_EASING } }, }, SLIDE_IN_LEFT: { hidden: { x: -50, opacity: 0 }, show: { x: 0, opacity: 1, transition: { duration: ANIM_DURATION, ease: ANIM_EASING } }, }, SLIDE_IN_RIGHT: { hidden: { x: 50, opacity: 0 }, show: { x: 0, opacity: 1, transition: { duration: ANIM_DURATION, ease: ANIM_EASING } }, }, ZOOM_IN: { hidden: { scale: 0.8, opacity: 0 }, show: { scale: 1, opacity: 1, transition: { duration: ANIM_DURATION, ease: ANIM_EASING } }, }, FLIP_IN_X: { hidden: { rotateX: 90, opacity: 0, transformPerspective: 600 }, show: { rotateX: 0, opacity: 1, transition: { duration: ANIM_DURATION, ease: ANIM_EASING } }, }, FLIP_IN_Y: { hidden: { rotateY: 90, opacity: 0, transformPerspective: 600 }, show: { rotateY: 0, opacity: 1, transition: { duration: ANIM_DURATION, ease: ANIM_EASING } }, }, };
const SectionTag = motion.section;
const transitionProps = { variants: transitionVariants[TRANSITION_ANIM_TYPE], initial: "hidden", whileInView:"show", viewport: { once: true, amount: 0 }, };

return (
 <SectionTag {...transitionProps} className="mt-32 w-full bg-gradient-to-b from-background from-10% via-secondary/20 via-60% to-background"><div className="flex flex-col items-center">
  <div className="h-[60vh] flex flex-col items-center justify-center flex-grow w-full gap-8 px-4 py-20 lg:px-10">
    <h1 className="text-center text-5xl font-bold sm:text-7xl">
      <span>
        Oups. Cette page n'existe pas.
      </span>
    </h1>
    <p className="text-lg text-center text-muted-foreground max-w-3xl">
      <span>
        Vous cherchez une réponse, mais notre IA RH ne connaît pas ce chemin.
      </span>
      <span>
        Peut-être que la ressource
      </span>
      <span>
        a été déplacée ou supprimée.
      </span>
      <span>
        Besoin d'aide ou d'informations RH ?
      </span>
      <span>
        Notre chatbot reste disponible pour vos questions.
      </span>
    </p>
    <a className={`inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 p-3 bg-primary text-primary-foreground shadow hover:bg-primary/90 px-6 py-3 text-lg font-medium transition rounded-md shadow-md`} href="/">
      <span>
        Retour à l'accueil
      </span>
    </a>
  </div></div></SectionTag>
); }
